import swal from 'sweetalert';

/**
 * Displays a SweetAlert and optionally executes a callback function when the user clicks 'OK'.
 *
 * @param {object} options - The options for the alert.
 * @param {'success' | 'error' | 'warning' | 'info'} [options.type='info'] - The type of the alert icon.
 * @param {string} options.message - The main message to display in the alert.
 * @param {string} options.title - The title of the alert.
 * @param {Function} [onConfirm] - The function to execute after the user confirms the alert.
 * @param {object} [options.props] - Additional properties to pass to the sweetalert function.
 */
export const showAlert = ({
  type = "info",
  message,
  title,
  ...props
}, onConfirm) => {
  const sweetAlertIcons = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
  };

  const icon = sweetAlertIcons[type] || 'info';

  swal({
    title: title,
    text: message,
    icon: icon,
    ...props,
  }).then((willConfirm) => {
    if (willConfirm && typeof onConfirm === 'function') {
      onConfirm();
    }
  });
};
